import BasicRepository, {ListArgs} from "./basicRepository";
import Client from "../client";
import {EventCategoryResource, EventGroupResource} from "../resources";
import {EventResource} from "client/resources/eventResource";

interface EventListArgs extends ListArgs {
    from?: string;
    to?: string;
    fromAutoId?: number;
    toAutoId?: number;
    asCsv?: boolean;
    regarding?: string[];
    regardingAny?: string[];
    internal?: boolean;
    users?: string[];
    projects?: string[];
    environments?: string[];
    eventGroups?: string[];
    eventCategories?: string[];
    tenants?: string[];
    tags?: string[];
    documentTypes?: string[];
}

class EventRepository extends BasicRepository<EventResource, EventListArgs> {
    constructor(client: Client) {
        super("Events", client);
    }

    categories(options: any): Promise<EventCategoryResource[]> {
        return this.client.get<EventCategoryResource[]>(this.client.getRootDocument().Links["EventCategories"], options);
    }

    groups(options: any): Promise<EventGroupResource[]> {
        return this.client.get<EventGroupResource[]>(this.client.getRootDocument().Links["EventGroups"], options);
    }

    documentTypes(options: any): Promise<EventGroupResource[]> {
        return this.client.get<EventGroupResource[]>(this.client.getRootDocument().Links["EventDocumentTypes"], options);
    }
}

export default EventRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/eventRepository.ts